@let subCriteria = score();
<span class="font-semibold">{{ subCriteria?.label ?? '' }}</span>
@if (subCriteria && subCriteria.percentage !== null) {
  <span class="text-sm">
    {{ subCriteria.percentage | appNumber: '1.0-0' }}%
    {{ 'project.steps.providerResults.individual.fulfilment' | transloco }}
  </span>
}
